export default __webpack_public_path__ + "static/media/cameraSVG.b0ea82af.svg";